module.exports = __webpack_public_path__ + "media/tip.05895ebc.mp3";